import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { IFavouriteDeparturesBestPricesResponse } from "../../Orchestrator/Types/Interface/IFavouriteDeparturesBestPrices";

type Result = IApiResponse<IFavouriteDeparturesBestPricesResponse>;

let inFlight: Promise<Result> | null = null;

export async function getFavouriteDeparturesBestPrices(
    showLoader?: boolean,
): Promise<Result> {
    // Single-flight: concurrent callers (e.g. favourite-departures + popular-trips)
    // share the same request so we only hit the network once per page load.
    if (inFlight) return inFlight;

    inFlight = (async () => {
        const ENDPOINTS = await getEndpoints();
        const endpoint = `${ENDPOINTS.favouriteDeparturesBestPrices}`;
        return apiRequest<IFavouriteDeparturesBestPricesResponse>(
            endpoint,
            'GET',
            {},
            'classic',
            undefined,
            undefined,
            showLoader,
        );
    })().finally(() => {
        inFlight = null;
    });

    return inFlight;
}
